module.exports = __webpack_public_path__ + "static/media/delivery.59f59e7a.png";